export function PlayIcon(props) {
  const { className, ...rest } = props;
  return (
    <svg className={className} {...rest} width='16' height='16' viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.804 7.99848L5 4.63148V11.3655L10.804 7.99848ZM11.596 7.30248C11.7186 7.37268 11.8205 7.47401 11.8913 7.59623C11.9622 7.71845 11.9995 7.85721 11.9995 7.99848C11.9995 8.13976 11.9622 8.27852 11.8913 8.40074C11.8205 8.52296 11.7186 8.62429 11.596 8.69448L5.233 12.3865C4.713 12.6885 4 12.3435 4 11.6905V4.30648C4 3.65348 4.713 3.30848 5.233 3.61048L11.596 7.30248Z' />
    </svg>
  );
}
